/**
 * Página pública de verificación de informe de mantención
 * Accesible sin autenticación — URL: /verificar-informe/:token
 *
 * @module pages/VerificarInforme
 */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import '../styles/pages/verificar-informe.css';

/**
 * Página pública de verificación de informe de mantención
 * Accesible sin autenticación — URL: /verificar-informe/:token
 *
 * @returns {JSX.Element}
 */
function VerificarInforme() {
  const { token }             = useParams();
  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  useEffect(() => {
    if (!token) { setError('URL inválida'); setLoading(false); return; }
    fetch(`/api/informes/verificar/${token}`)
      .then(r => r.json())
      .then(json => {
        if (json.success) setData(json.data);
        else setError('Informe no encontrado');
      })
      .catch(() => setError('Error al verificar el informe'))
      .finally(() => setLoading(false));
  }, [token]);

  const formatFecha = (ts) => new Date(ts).toLocaleString('es-CL', {
    timeZone: 'America/Santiago', dateStyle: 'long', timeStyle: 'medium'
  });

  if (loading) return (
    <div className="verificar-informe__loading">
      <p>Verificando informe...</p>
    </div>
  );

  return (
    <div className="verificar-informe">
      <h1 className="verificar-informe__titulo">Verificación de Informe</h1>
      <p className="verificar-informe__subtitulo">
        Sistema de gestión DESMAQ — Firma Electrónica Simple (Ley N° 19.799)
      </p>

      {error ? (
        <div className="verificar-informe__alerta-error">
          <strong><i className="fas fa-exclamation-triangle" /> {error}</strong>
        </div>
      ) : (
        <div className="verificar-informe__card">
          <div className="verificar-informe__header">
            <i className="fas fa-check-circle verificar-informe__icono" />
            <div>
              <strong>Informe Verificado</strong>
              <p className="verificar-informe__ot">
                OT {data.codigo_ot} — {data.equipo_codigo} {data.marca} {data.modelo}
              </p>
            </div>
          </div>
          <table className="verificar-informe__tabla">
            <tbody>
              {[
                ['Firmado por', `${data.firmado_por_nombre || ''} (${data.firmado_por})`],
                ['Fecha y hora', formatFecha(data.firmado_at)],
                ['Tamaño del documento', data.tamano_bytes ? `${(data.tamano_bytes / 1024).toFixed(1)} KB` : '—'],
              ].map(([label, value]) => (
                <tr key={label}>
                  <td>{label}</td>
                  <td>{value}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="verificar-informe__hash">
            <p>Hash SHA-256 del documento:</p>
            <code>{data.firma_hash}</code>
          </div>
        </div>
      )}
    </div>
  );
}

export default VerificarInforme;
